import { ObjectTypes } from '../../../../utils/constants';
import { doSearchStoreAction, loadGridColumnSettingStoreAction, loadSavedFilterStoreAction } from '../../../Generic/SearchPage/actions/searchPageActions';
import { OrderSearchActions as searchPageSliceActions } from '../slice/OrdersSlice';
import { getEndDateWithTime, getStartDateWithTime } from '../../../../utils/constants/datetime';
import OrderApi from '../../../../services/api/OrderApi';
import { getUserTimezone } from '../../../../hooks/useAuth';

const getStateSliceForSearchPage = (state) => state.OrderSearch;

export const loadGridColumnSettingStoreActionHandler = () => async (dispatch, getState) => loadGridColumnSettingStoreAction({
  dispatch,
  getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  objectTypeGridColumns: ObjectTypes.OrderSearchGrid
});

export const loadSavedFilterStoreActionHandler = () => async (dispatch, getState) => loadSavedFilterStoreAction(
  {
    dispatch,
    getState,
    searchPageSliceActions,
    getStateSliceForSearchPage,
    objectTypeForSaveUserFilter:
      ObjectTypes.OrderSearchUserFilter
  }
);

export const doSearchStoreActionHandler = () => async (dispatch, getState) => {
  const state = getState();
  // const clientIDs = getClientIdsScreenAccessByState(state, 'Orders');
  const timezone = getUserTimezone(state);
  const searchParamBuilder = (filter) => ({
    orderNumber: filter?.orderNumber ?? '',
    statusIDs: filter?.statusIDs ?? [],
    requestor: filter?.requestor || null,
    rushOrder: filter?.rushOrder ?? false,
    clientIDs: filter?.clientIDs ?? [],
    reportAddressIDs: filter?.reportAddressIDs ?? [],
    invoiceAddressIDs: filter?.invoiceAddressIDs ?? [],
    scenarioIDs: filter?.scenarioIDs ?? [],
    companyName: filter?.companyName ?? '',
    dueDateFrom: filter?.dueDateFrom ? getStartDateWithTime(filter?.dueDateFrom, timezone).toISOString() : null,
    dueDateTo: filter?.dueDateTo ? getEndDateWithTime(filter?.dueDateTo, timezone).toISOString() : null,
    orderDateFrom: filter?.orderDateFrom ? getStartDateWithTime(filter?.orderDateFrom, timezone).toISOString() : null,
    orderDateTo: filter?.orderDateTo ? getEndDateWithTime(filter?.orderDateTo, timezone).toISOString() : null,
    ShipCity: filter?.ShipCity ?? '',
    supplyTypes: filter?.supplyTypes ?? [],
    templateNo: filter?.templateNo ?? null,
    shipToFacility: filter?.shipToFacility || null,
    shipToCompany: filter?.shipToCompany ?? [],
    functionality: filter?.functionality ?? 'Order'
  });

  await doSearchStoreAction({
    dispatch,
    getState,
    searchPageSliceActions,
    getStateSliceForSearchPage,
    searchParamBuilder,
    searchWithPaginationApi: OrderApi.searchOrders,
  });
};
